import React from "react";
import { useField, FieldValidator } from "formik";
import Error from "./Error";
import { styles as textInputStyles } from "./TextField";
import RequiredDot from "./RequiredDot";

type Props = {
  autoComplete?: string;
  children: React.ReactNode;
  label?: string;
  multiple?: boolean;
  name: string;
  required?: boolean;
  validate?: FieldValidator;
  value: string;
};

export default function Select({
  autoComplete,
  name,
  label,
  required = false,
  multiple = false,
  children,
}: Props) {
  const [field, { error, touched }] = useField({ name, multiple: multiple });

  const errorId = `${name}ErrorDescription`;
  const calculatedAriaDescribedBy = error ? errorId : "";

  return (
    <div className="w-full">
      {label ? (
        <div className="mb-1 flex">
          <label htmlFor={name}>{label}</label>
          {required && <RequiredDot />}
        </div>
      ) : null}

      <select
        {...field}
        aria-invalid={error ? "true" : undefined}
        aria-describedby={calculatedAriaDescribedBy}
        autoComplete={autoComplete}
        id={name}
        className={textInputStyles({ touched, error }) + " max-h-10"}
        data-testid={`${name}-select`}
      >
        {children}
      </select>

      <div className="mt-2 md:mt-1">
        {touched && error && <Error id={errorId} errorText={error} />}
      </div>
    </div>
  );
}
